"use strict";
"use es6";

/*
* The track.toIoPath bridge method exists for 2 reasons:
*
*   1. Provide a convenient method for unit test specs to spy on when asserting that an event
*      was made it through the tracker and back to the client.
*   2. Provide a bridge that connects tracker options -> client provided IO paths (network, pool, etc)
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
var toIoPath = exports.toIoPath = function toIoPath(_ref) {
  var sendToPool = _ref.sendToPool,
      sendToNetwork = _ref.sendToNetwork;
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var eventPayload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var bypassPool = config.bypassPool,
      isBeforeUnload = config.isBeforeUnload,
      identifiers = config.identifiers;


  if (bypassPool || isBeforeUnload) {
    sendToNetwork({
      identifiers: identifiers,
      isBeforeUnload: isBeforeUnload
    }, [eventPayload]);
  } else {
    sendToPool({
      identifiers: identifiers
    }, eventPayload);
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.87/js/track/index.js
// module id = 413
// module chunks = 0